// @flow
import React from 'react'
import { Link } from 'react-router'
import Helmet from 'react-helmet'

const NotFound = () => (
  <div style={{ margin: '2rem auto', textAlign: 'center' }}>
    <Helmet title="404" />
    <p>Page not found</p>
    <p>
      <Link to="/">Go to the home page →</Link>
    </p>
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/views/NotFound/index.js